import BreadCrump from "../tools/breadcrump"
import { getCookies } from "cookies-next";
import { useEffect, useState } from "react";
import axios from "axios";
import { config } from "../../data/config";
import { useTranslation } from 'react-i18next';
import HeaderOfPage from "../tools/headerOfPage";

const STATUS_CONFIG: Record<string, { text: string; className: string; accent: string }> = {
    pending: { text: 'پرداخت نشده', className: 'bg-amber-50 text-amber-700 ring-amber-200', accent: 'border-r-amber-400' },
    paid: { text: 'پرداخت شده', className: 'bg-emerald-50 text-emerald-700 ring-emerald-200', accent: 'border-r-emerald-400' },
    canceled: { text: 'کنسل شده', className: 'bg-red-50 text-red-700 ring-red-200', accent: 'border-r-red-400' },
    sending: { text: 'در حال ارسال', className: 'bg-blue-50 text-blue-700 ring-blue-200', accent: 'border-r-blue-400' },
    archive: { text: 'بایگانی', className: 'bg-gray-50 text-gray-700 ring-gray-200', accent: 'border-r-gray-400' },
};

/** Compact page list: 1 … 4 5 6 … 43 */
function getVisiblePages(current: number, total: number): (number | 'ellipsis')[] {
    if (total <= 7) {
        return Array.from({ length: total }, (_, i) => i + 1);
    }

    const pages = new Set<number>();
    pages.add(1);
    pages.add(total);
    for (let i = current - 1; i <= current + 1; i++) {
        if (i >= 1 && i <= total) pages.add(i);
    }
    if (current <= 3) {
        pages.add(2);
        pages.add(3);
        pages.add(4);
    }
    if (current >= total - 2) {
        pages.add(total - 1);
        pages.add(total - 2);
        pages.add(total - 3);
    }

    const sorted = Array.from(pages).sort((a, b) => a - b);
    const result: (number | 'ellipsis')[] = [];
    for (let i = 0; i < sorted.length; i++) {
        if (i > 0 && sorted[i] - sorted[i - 1] > 1) {
            result.push('ellipsis');
        }
        result.push(sorted[i]);
    }
    return result;
}

export default function InvoiceList() {
    const breadcrump = [
        { name: 'Dashboard', url: '/dashboard' },
        { name: 'َکاربران', url: '/dashboard/user' },
        { name: 'لیست فاکتورها', url: null },
    ];

    return (
        <div className="text-left directions bg-white p-4 sm:p-6 m-4 rounded-xl shadow-sm border border-gray-100 min-h-[calc(100vh-2rem)] mb-5">
            <BreadCrump data={breadcrump}></BreadCrump>
            <HeaderOfPage name="لیست فاکتورها"></HeaderOfPage>
            <ListofBlog />
        </div>
    );
}

function ListofBlog() {
    const { t } = useTranslation();
    const cookie = getCookies();
    const [list, setList] = useState<any>(null);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(true);

    const getalldata = async () => {
        setLoading(true);
        try {
            const res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/invoices?page=' + page,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                },
            });
            setList(res.data.message);
        } catch (error) {
            // ignore
        } finally {
            setLoading(false);
        }
    };

    const toJalali = (date: string) => {
        const utcDate = new Date(date);
        return utcDate.toLocaleString('fa-IR', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    };

    const formatPrice = (price: number | string) => {
        const num = Number(price);
        if (Number.isNaN(num)) return String(price);
        return num.toLocaleString('fa-IR');
    };

    useEffect(() => {
        getalldata();
    }, [page]);

    const goToPage = (next: number) => {
        if (!list || next < 1 || next > list.totalPages || next === list.page) return;
        setPage(next);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const renderStatusBadge = (status: string) => {
        const cfg = STATUS_CONFIG[status] || {
            text: status,
            className: 'bg-gray-50 text-gray-700 ring-gray-200',
        };
        return (
            <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold ring-1 ${cfg.className}`}>
                {cfg.text}
            </span>
        );
    };

    const docs = list?.docs?.filter((item: any) => item.touser != null) ?? [];

    return (
        <div className="directions">
            {loading && (
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                    {[1, 2, 3, 4, 5, 6].map((i) => (
                        <div key={i} className="h-[148px] rounded-xl border border-gray-100 bg-gray-50 animate-pulse" />
                    ))}
                </div>
            )}

            {!loading && docs.length === 0 && (
                <div className="flex flex-col items-center justify-center py-16 px-4 rounded-xl border border-dashed border-gray-200 bg-gray-50/50">
                    <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mb-3 text-gray-400">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                            <polyline points="14 2 14 8 20 8" />
                            <line x1="16" y1="13" x2="8" y2="13" />
                            <line x1="16" y1="17" x2="8" y2="17" />
                        </svg>
                    </div>
                    <p className="text-sm font-medium text-gray-700">فاکتوری یافت نشد</p>
                    <p className="text-xs text-gray-500 mt-1">هنوز فاکتوری در سیستم ثبت نشده است</p>
                </div>
            )}

            {!loading && docs.length > 0 && (
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                    {docs.map((item: any) => {
                        const accent = STATUS_CONFIG[item.status]?.accent || 'border-r-gray-300';
                        const displayName = item.touser?.name?.trim() || item.touser?.mobile || '—';
                        const showMobileUnderName = Boolean(item.touser?.name?.trim() && item.touser?.mobile);
                        return (
                            <a
                                key={item.id}
                                href={`/dashboard/User/invoices/${item.id}`}
                                className={`group block rounded-xl border border-gray-100 bg-white shadow-sm hover:shadow-md hover:border-gray-200 transition-all duration-200 overflow-hidden border-r-4 ${accent}`}
                            >
                                <div className="p-4 flex flex-col gap-3 h-full">
                                    <div className="flex items-start justify-between gap-3">
                                        <div className="min-w-0 flex-1 text-right">
                                            <h3 className="text-sm font-semibold text-gray-900 truncate">
                                                {displayName}
                                            </h3>
                                            {showMobileUnderName && (
                                                <p className="text-xs text-gray-500 mt-1 font-mono tracking-wide" dir="ltr">
                                                    {item.touser.mobile}
                                                </p>
                                            )}
                                        </div>
                                        {renderStatusBadge(item.status)}
                                    </div>

                                    <div className="grid grid-cols-2 gap-3 pt-3 border-t border-gray-100 mt-auto">
                                        <div className="text-right">
                                            <p className="text-[11px] text-gray-400 mb-0.5">قیمت کل</p>
                                            <p className="text-sm font-bold text-gray-900 tabular-nums">
                                                {formatPrice(item.totalprice)}
                                                <span className="text-[11px] font-medium text-gray-500 mr-1">تومان</span>
                                            </p>
                                        </div>
                                        <div className="text-right">
                                            <p className="text-[11px] text-gray-400 mb-0.5">{t('تاریخ')}</p>
                                            <p className="text-xs text-gray-600">{toJalali(item.createdAt)}</p>
                                        </div>
                                    </div>

                                    <div className="flex items-center justify-start gap-1.5 text-xs font-medium text-gray-400 group-hover:text-blue-600 transition-colors pt-1">
                                        <span>مشاهده فاکتور</span>
                                        <svg className="size-3.5 transition-transform group-hover:-translate-x-0.5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="m15 18-6-6 6-6" />
                                        </svg>
                                    </div>
                                </div>
                            </a>
                        );
                    })}
                </div>
            )}

            {list != null && list.totalPages > 1 && (
                <div className="mt-6 pt-5 border-t border-gray-100 flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="text-xs text-gray-500 order-2 sm:order-1 tabular-nums">
                        صفحه{' '}
                        <span className="font-semibold text-gray-800">{list.page.toLocaleString('fa-IR')}</span>
                        {' '}از{' '}
                        <span className="font-semibold text-gray-800">{list.totalPages.toLocaleString('fa-IR')}</span>
                        {list.totalDocs != null && (
                            <>
                                {' '}·{' '}
                                <span className="font-semibold text-gray-800">{Number(list.totalDocs).toLocaleString('fa-IR')}</span>
                                {' '}فاکتور
                            </>
                        )}
                    </p>

                    <nav className="flex items-center gap-1 order-1 sm:order-2" aria-label="Pagination">
                        <button
                            onClick={() => goToPage(list.page - 1)}
                            type="button"
                            disabled={list.prevPage == null}
                            className="min-h-9 min-w-9 px-2.5 inline-flex justify-center items-center gap-1.5 rounded-lg border border-gray-200 bg-white text-sm text-gray-700 hover:bg-gray-50 hover:border-gray-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/40 disabled:opacity-40 disabled:pointer-events-none transition-colors"
                            aria-label="صفحه قبل"
                        >
                            <svg className="shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="m9 18 6-6-6-6" />
                            </svg>
                            <span className="hidden sm:inline text-xs font-medium">قبلی</span>
                        </button>

                        <div className="flex items-center gap-0.5 mx-0.5">
                            {getVisiblePages(list.page, list.totalPages).map((item, idx) =>
                                item === 'ellipsis' ? (
                                    <span
                                        key={`e-${idx}`}
                                        className="min-h-9 min-w-8 flex items-center justify-center text-gray-400 text-sm select-none"
                                        aria-hidden="true"
                                    >
                                        …
                                    </span>
                                ) : list.page === item ? (
                                    <button
                                        key={item}
                                        type="button"
                                        className="min-h-9 min-w-9 flex justify-center items-center rounded-lg bg-gray-900 text-white text-sm font-semibold tabular-nums shadow-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-900/30"
                                        aria-current="page"
                                    >
                                        {item.toLocaleString('fa-IR')}
                                    </button>
                                ) : (
                                    <button
                                        key={item}
                                        onClick={() => goToPage(item)}
                                        type="button"
                                        className="min-h-9 min-w-9 flex justify-center items-center rounded-lg border border-transparent text-sm text-gray-700 tabular-nums hover:bg-gray-100 hover:border-gray-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/40 transition-colors"
                                    >
                                        {item.toLocaleString('fa-IR')}
                                    </button>
                                )
                            )}
                        </div>

                        <button
                            onClick={() => goToPage(list.page + 1)}
                            type="button"
                            disabled={list.nextPage == null}
                            className="min-h-9 min-w-9 px-2.5 inline-flex justify-center items-center gap-1.5 rounded-lg border border-gray-200 bg-white text-sm text-gray-700 hover:bg-gray-50 hover:border-gray-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/40 disabled:opacity-40 disabled:pointer-events-none transition-colors"
                            aria-label="صفحه بعد"
                        >
                            <span className="hidden sm:inline text-xs font-medium">بعدی</span>
                            <svg className="shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="m15 18-6-6 6-6" />
                            </svg>
                        </button>
                    </nav>
                </div>
            )}
        </div>
    );
}
